import AxiosJob from '@/services/api/job/axios_job'

export default {
  createCampaign: (data) => {
    return AxiosJob.post('campaign', data)
  },

  updateCampaign: (campaignId, data) => {
    return AxiosJob.put(`campaign/${campaignId}`, data)
  },

  getAllCampaigns: (params) => {
    return AxiosJob.get('campaign', { params })
  },

  getCampaignsByCustomer: (customerId, params) => {
    return AxiosJob.get(`campaign/customer/${customerId}`, { params })
  },

  getCampaign: (campaignId) => {
    return AxiosJob.get(`campaign/${campaignId}`)
  },

  deleteCampaign: (campaignId) => {
    return AxiosJob.delete(`campaign/${campaignId}`)
  }
}

